import React from 'react';
import { View, Text, StyleSheet, Platform, Keyboard, TouchableOpacity } from 'react-native';
import CS from '../../constants/Styles';
import TextInputContainer from '../../components/TextInputContainer';
import { Button, Loader, Validate, BackgroundGradient, SafeAreaView, Alert } from '../../components';
import { FontAwesome, FontAwesome5 } from '@expo/vector-icons';
import Colors from '../../constants/Colors';
import * as rtApi from '../../components/Api';
import { useFocusEffect } from '@react-navigation/native';
import { useLinkTo } from '@react-navigation/native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';

const iconSize = 52;

const ForgotPasswordScreen = ({navigation, route}) => {
  const [username, setUsername] = React.useState('');
  const [resetOccured, setResetOccured] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [messages, setMessages] = React.useState([]);
  const [alertOptions, setAlertOptions] = React.useState({});

  let usernameInput = React.useRef(null);

  const linkTo = useLinkTo();
  
  // const ac = new AbortController();

  const defaultMessages = [
    'Click on the push notification',
    'Check your email for a link to reset your password',
    'Click the link in the text message we sent you',
  ];

  useFocusEffect(
    React.useCallback(() => {
      setResetOccured(false);
    }, [])
  );

  function checkUsername() {
    if (!Validate.Email(username)) {
      // Alert.alert('Invalid', 'Please enter a valid username');
      setAlertOptions({ visible: true, title: 'Invalid', message: 'Please enter a valid email address', });
      return;
    }
    reset();
  }
  
  function reset(){
    setLoading(true);

    let fd = new FormData();
    fd.append('username', username);

    rtApi.post('login/forgot/generate', fd)
    .then(data => {
      console.log('data: ', data);
      if (data.result) {
        let newMessages = [];
        if (data.push) {
          newMessages.push(defaultMessages[0]);
        }
        if (data.email) {
          newMessages.push(defaultMessages[1]);
        }
        if (data.sms) {
          newMessages.push(defaultMessages[2]);
        }
        setMessages(newMessages);
        setResetOccured(true);
      } else {
        throw (data.errors.join('; '));
      }
    }).catch(err => {
      setResetOccured(false);
      setUsername('');
      usernameInput.current.focus();
    }).finally(() => {
      setLoading(false);
    });
  }

  function goToLogin(){
    linkTo('/login');
  }
  return (
    <SafeAreaView style={CS.safe}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <Alert options={alertOptions} setOptions={setAlertOptions} />
      <KeyboardAwareScrollView keyboardShouldPersistTaps='handled' style={styles.container} contentContainerStyle={styles.innerContainer} keyboardDismissMode='on-drag'>
        <TouchableOpacity onPress={goToLogin} style={styles.backArrow}>
          <FontAwesome5 name="arrow-left" size={24} color="white" />
        </TouchableOpacity>
        {!resetOccured ? (
          <>
            <View style={styles.iconTextContainer}>
              <View style={[styles.iconContainer, { marginRight: 20 }]}>
                <FontAwesome name='lock' color={Colors.yellow} size={iconSize} style={styles.icon} />
              </View>
              <Text style={[CS.largeTitle, CS.lightText, CS.flex]}>Forgot Your Password?</Text>
            </View>
            <TextInputContainer
              autoFocus={true}
              iconName='envelope'
              placeholder='Username'
              textContentType='username'
              onChangeText={(t) => setUsername(t)}
              keyboardType='email-address'
              autoCapitalize='none'
              spellCheck={false}
              onSubmitEditing={() => checkUsername()}
              returnKeyType='done'
              inputRef={usernameInput}
              selectTextOnFocus={true}
              value={username}
            />
            {/* <TextInput
                  style={{ borderWidth: 1, borderColor: 'grey', padding: 10, width: '100%' }}
                  textContentType='newPassword'
                  passwordRules="minlength: 15; maxlength: 15; required: lower; required: upper; required: digit; required: [-];"
                /> */}
            <Button text='Reset Password' onPress={() => checkUsername} />
          </>
        ) : (
          <>
            <Text style={[CS.mediumTitle, CS.lightText, styles.title]}>We've sent you instructions to reset your password</Text>
            <View style={styles.iconOuter}>
              <View style={styles.iconContainer}>
                <FontAwesome name='check' color={Colors.yellow} size={iconSize} style={styles.icon} />
              </View>
            </View>

            <View style={styles.messageContainer}>
              <Text style={[CS.mediumText, CS.lightBlueText, styles.message]}>{messages[0]}</Text>
              {messages.length === 2 &&
                <>
                  <Text style={[CS.mediumText, CS.lightBlueText, styles.or]}>or</Text>
                  <Text style={[CS.mediumText, CS.lightBlueText, styles.message]}>{messages[1]}</Text>
                </>
              }
            </View>
            <Button text='Ok' onPress={() => goToLogin} />
          </>
        )}
      </KeyboardAwareScrollView>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    // marginTop: 20,
    width: '100%',
    // marginVertical: 10,
    padding: 10,
    // backgroundColor: 'pink',
  },
  innerContainer: {
    width: '100%',
    // backgroundColor: 'blue',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    justifyContent: 'center',
    flexGrow: 1,
    alignSelf: 'center'
  },
  // innerContainer: {
  //   width: '100%',
  //   // backgroundColor: 'blue',
  //   maxWidth: Platform.OS === 'web' ? 768 : '100%',
  //   justifyContent: 'center',
  //   flexGrow: 1,
  //   alignSelf: 'center',
  // },
  iconTextContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom:40,
  },
  iconContainer: {
    padding: 20,
    borderStyle: 'solid',
    borderWidth: 3,
    borderColor: Colors.lightBlue,
    borderRadius: 10,
    // marginTop: 20,
    // marginBottom: 30,
    marginHorizontal: 0,
    // marginRight:20,
    // backgroundColor:'pink'
  },
  iconOuter: {
    alignItems: 'center',
  },
  icon: {
    ...Platform.select({
      ios: {
        shadowColor: Colors.darkGrey,
        shadowOffset: { width: 10, height: 10 },
        shadowOpacity: 1,
        shadowRadius: 4,
      },
      android: {
        shadowColor: Colors.darkGrey,
        shadowOffset: { width: 10, height: 10 },
        shadowOpacity: 1,
        shadowRadius: 4,
      },
    })
  },
  title: {
    marginBottom: 40,
    textAlign: 'center',
  },
  messageContainer: {
    width: '100%',
    marginVertical: 40,
    alignItems: 'center',
  },
  message: {
    width: '80%',
    textAlign: 'center',
  },
  or: {
    marginVertical: 10,
  },
  backArrow: {
    position: 'absolute',
    top:10,
    left: 10,
  }
})

export default ForgotPasswordScreen;